/**
 * 
 * @param {*} data 
 */
/**
 * 加密
 * @param {*} value 要加密的字符串
 */
const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCpC4QMnbTrQOFriJJCCFFWhlruBJThAEBfRk7pRx1jsAhyNVL3CqJb0tRvpnbCnJhrRAEPdgFHXv5A0RrvFp+5Cw7QoFH6O9rKB8+0H7+aVQeKITMUHf/XMXioymw6Iq4QfWd8RhdtM1KM6eGTy8aU7SO2s69Mc1LXefg/x3yw6wIDAQAB';
const $encrypt = (value) => {
        if (value == null || value === '') return null;
        let encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);
        return encodeURIComponent(encrypt.encrypt(value));
    }
    /**
     * @author shi
     * @description 将json格式form序列化为formdata
     * @param {Object} data
     * @returns {FormData}
     */
const $formDataFormat = data => {
    const formData = new FormData();
    for (const key in data) {
        formData.append(key, data[key]);
    }
    return formData;
};

const $URLSearchParams = data => {
    const params = new URLSearchParams();
    for (const key in data) {
        params.append(key, data[key]);
    }
    return params;
};

const $toTop = () => {
    // $("html,body").animate({ scrollTop: "0px" })
    window.scrollTo({
        top: 0,
        behavior: 'smooth',
    });
};
/**
 * @author shi
 * @param {void}
 * @returns {Number}
 * @description 随机数
 */
const $getUUID = () => Math.round(Math.random() * new Date().getTime());

/**
 * @author shi
 * @param {void}
 * @returns {JSON}
 * @description token
 */
const $getToken = () => $session.get('userinfo').replace(/"/g, '');

const $encode = (data) => window.btoa(encodeURI(JSON.stringify(data)));

const $decode = (data) => JSON.parse(decodeURI(window.atob(data)));
/**
 * @author shi
 * @description 防抖
 * @param {Function} func
 * @param {Number} wait
 * @return {Function}
 */
const $debounce = (func, wait) => {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            func.apply(context, args);
        }, wait);
    };
};

/**
 * @author shi
 * @description 节流
 */

const $throttle = (fn, time) => {
    let flag = true;
    return function() {
        if (!flag) return;
        flag = false;
        setTimeout(() => {
            fn.apply(this, arguments);
            flag = true;
        }, time);
    };
};

/**
 * @author shi
 * @description 本地存储对象
 */
const $storage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        return JSON.parse(Storage.getItem(key));
    },
    remove(key) {
        localStorage.removeItem(key);
    },
};

const $session = {
    set(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        return JSON.parse(sessionStorage.getItem(key));
    },
    remove(key) {
        sessionStorage.removeItem(key);
    },
};

/**
 * @author shi
 * @description 是否是一个对象
 * @param {Object} obj
 */
const $isObj = (obj) => Object.prototype.toString.call(obj) === '[object Object]';

/**
 * @author shi
 * @description 对象是否为空
 * @param {*} obj
 */
const $isEmptyObj = (obj) => $isObj(obj) && Boolean(Object.keys(obj).length);

/**
 * @param {*long} timestamp 时间戳（单位：毫秒），形如：1550789954260
 * @param {[string]} fmt 时间格式 形如   默认 fmt='yyyy-MM-dd'
 */
const $formatDate = (date, fmt = 'yyyy-MM-dd') => {
    const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds(), // 毫秒
    };
    if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
    }
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
        }
    }
    return fmt;
};

/**
 * @author shi
 * @description 延迟加载
 * @param {Number} ms 毫秒数
 * @return  {Promise}
 */

const $delay = ms => new Promise((resolve) => setTimeout(resolve, ms));

/**
 * @author shi
 * @description 获取域名
 */
const $getDomain = () => window.location.hostname; // 'http://cs8.rocwo.cn'// window.location.hostname  //'http://cs8.rocwo.cn' //window.location.hostname //'www.ala.com'


/**
 * @author shi
 * @description 对比对象内容是否相同
 * @param {object} a
 * @param {object} b
 */
const $isObjectValueEqual = (a, b) => {
    if (!$isObj(a) && !$isObj(b)) {
        return false;
    }
    const aProps = Object.keys(a);
    const bProps = Object.keys(b);
    if (aProps.length != bProps.length) {
        return false;
    }
    for (let i = 0; i < aProps.length; i++) {
        const propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
};

/**
 * @author shi
 * @description 对比数组内容是否相同  不论顺序
 * @param {Array} arr1
 * @param {Array} arr2
 */
const $arrEquals = (arr1, arr2) => {
    const m = new Map();
    arr1.forEach(o => m.set(o, (m.get(o) || 0) + 1));
    arr2.forEach(o => m.set(o, (m.get(o) || 0) - 1));
    for (const key of m.values()) {
        if (key !== 0) return false;
    }
    return true;
};

/**
 * 去除HTML标签
 * @author shi
 * @param {String} str
 * @param {String} allowed_tags
 * @returns {String}
 */
const $stripTags = (str, allowed_tags) => {
    let key = '';
    let allowed = false;
    let matches = [];
    let allowed_array = [];
    let allowed_tag = '';
    let i = 0;
    let k = '';
    let html = '';
    const replacer = (search, replace, str) => str.split(search).join(replace);
    // Build allowes tags associative array
    if (allowed_tags) {
        allowed_array = allowed_tags.match(/([a-zA-Z0-9]+)/gi);
    }
    str += '';

    // Match tags
    matches = str.match(/(<\/?[\S][^>]*>)/gi);
    // Go through all HTML tags
    for (key in matches) {
        if (Number.isNaN(key)) {
            // IE7 Hack
            continue;
        }

        // Save HTML tag
        html = matches[key].toString();
        // Is tag not in allowed list? Remove from str!
        allowed = false;

        // Go through all allowed tags
        for (k in allowed_array) { // Init
            allowed_tag = allowed_array[k];
            i = -1;

            if (i !== 0) {
                i = html.toLowerCase().indexOf(`<${allowed_tag}>`);
            }
            if (i !== 0) {
                i = html.toLowerCase().indexOf(`<${allowed_tag} `);
            }
            if (i !== 0) {
                i = html.toLowerCase().indexOf(`</${allowed_tag}`);
            }

            // Determine
            if (i === 0) {
                allowed = true;
                break;
            }
        }
        if (!allowed) {
            str = replacer(html, '', str); // Custom replace. No regexing
        }
    }
    return str;
};
const $findMenuItem = (menuItem, menuId, path) => {
    if (Array.isArray(path)) path.push(menuItem);
    if ((menuItem.menuId + '') === (menuId + '')) return menuItem;

    let bFind = false;
    let findItem = null;
    if (Array.isArray(menuItem.children)) {
        for (let i = 0; i < menuItem.children.length; i++) {
            findItem = $findMenuItem(menuItem.children[i], menuId, path);
            if (findItem != null) {
                bFind = true;
                break;
            }
        }
    }

    if (!bFind && Array.isArray(path)) path.pop();
    return bFind ? findItem : null;
}

const $treeDataTranslate = (data, id = 'id', pid = 'parentId') => {
    var res = []
    var temp = {};
    for (var i = 0; i < data.length; i++) {
        temp[data[i][id]] = data[i];
    }
    for (var k = 0; k < data.length; k++) {
        if (temp[data[k][pid]] && data[k][id] != data[k][pid]) {
            if (!temp[data[k][pid]]['children']) {
                temp[data[k][pid]]['children'] = []
            }
            if (!temp[data[k][pid]]['_level']) {
                temp[data[k][pid]]['_level'] = 1
            }
            data[k]['_level'] = temp[data[k][pid]]._level + 1
            data[k]['_parent'] = data[k][pid]
            temp[data[k][pid]]['children'].push(data[k])
        } else {
            res.push(data[k])
        }
    }
    return res
}

const $getObjectFromSessionStorage = (key, defaultValue) => {
    let jsonObj = null;
    try {
        jsonObj = $session.get(key);
        jsonObj = (jsonObj || {}).data;
    } catch (e) {
        jsonObj = defaultValue;
    }
    return (jsonObj != null) ? jsonObj : defaultValue;
}

const $setObjectToSessionStorage = (key, value) => {
    if (key == null || key === '') return false;
    if (value == null) {
        $session.remove(key);
        return true;
    } else {
        let jsonObj = {
            data: value
        }
        $session.set(key, jsonObj)
        return true;
    }
}

export {
    $storage,
    $session,
    $encrypt,
    $formDataFormat,
    $URLSearchParams,
    $debounce,
    $throttle,
    $getUUID,
    $getToken,
    $encode,
    $decode,
    $isObj,
    $isEmptyObj,
    $formatDate,
    $delay,
    $getDomain,
    $toTop,
    $isObjectValueEqual,
    $arrEquals,
    $stripTags,
    $findMenuItem,
    $treeDataTranslate,
    $getObjectFromSessionStorage,
    $setObjectToSessionStorage,
};